import { render, staticRenderFns } from "./loading1.vue?vue&type=template&id=373bd1bc&scoped=true"
var script = {}
import style0 from "./loading1.vue?vue&type=style&index=0&id=373bd1bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373bd1bc",
  null
  
)

export default component.exports